import { render, staticRenderFns } from "./DataRuleForm.vue?vue&type=template&id=bc3340f4"
import script from "./DataRuleForm.vue?vue&type=script&lang=js"
export * from "./DataRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3340f4')) {
      api.createRecord('bc3340f4', component.options)
    } else {
      api.reload('bc3340f4', component.options)
    }
    module.hot.accept("./DataRuleForm.vue?vue&type=template&id=bc3340f4", function () {
      api.rerender('bc3340f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/menu/DataRuleForm.vue"
export default component.exports